<template>
  <div
    class="submit-tender clearfix"
    style="display: inline-block"
    :hide-overlay="true"
  >
    <button
      type="button"
      class="btn btn--orange"
      id="start-addendum"
      slot="activator"
      @click="openModal()"
    >{{ $t('action.addendum') }}</button>
    <modal
      ref="modal"
      :modalId="`start-addendum-${+new Date()}`"
    >
      <div slot="content">
        <p class="modal-pure-text">{{ $t('warn.addendum.startAddendum') }}</p>
      </div>
      <div slot="btns">
        <button
          type="button"
          class="btn btn--darkblue"
          @click="closeModal()"
        >{{ $t('action.back') }}</button>
        <button
          type="button"
          class="btn btn--orange"
          @click="goAddendumEdit()"
        >{{ $t('action.yes') }}</button>
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from '@/controls/Modal'
import { tenderStatus } from '@/utils/locale'
import { mapActions } from 'vuex'
import { ActionTypes } from '@/utils/consts'

export default {
  name: 'ConfirmCreate',
  components: {
    Modal,
  },
  data () {
    return {
      prNumber: '',
      hint: '',
    }
  },
  methods: {
    ...mapActions('tenders', [
      'updateTenderStatus',
      'createRevision',
      'refreshTender',
    ]),
    openModal () {
      if (this.$refs.modal) {
        this.$refs.modal.open()
      }
    },
    closeModal () {
      if (this.$refs.modal) {
        this.$refs.modal.close()
      }
    },
    async goAddendumEdit () {
      try {
        this.closeModal()
        const id = this.$router.currentRoute.params.id
        this.$root.$children[0].$refs.loadingLayer.$emit('startLoading')
        await this.createRevision()
        await this.updateTenderStatus({
          id,
          status: tenderStatus.DRAFT,
          action: ActionTypes.tenders.addendum.create,
        })
        await this.refreshTender()
        this.$router.push({
          name: 'tenderAddendumDetails',
          params: {
            id,
          },
        })
      } finally {
        this.$root.$children[0].$refs.loadingLayer.$emit('stopLoading')
      }
    },
  },
}
</script>

<style lang="scss" >
@import '~styles/popup';
#start-addendum-container .confirm-header {
  margin-bottom: 0;
}

</style>
